
		import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "dreamland/jsx-runtime";
export const title = "How I hacked Arc Search";
export const tags = ["Writeup"];
export const image = "/blog-images/bfm-fake-quote.jpg";
export const description = "How I made an Arc Search Browse For Me shared link display arbitrary content, and why this can be abused.";
function _createMdxContent(props) {
  const _components = {
    a: "a",
    blockquote: "blockquote",
    code: "code",
    h2: "h2",
    img: "img",
    li: "li",
    p: "p",
    pre: "pre",
    span: "span",
    strong: "strong",
    ul: "ul",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(_components.p, {
      children: "Hello! In this article, I’d like to go over how I was able to make an Arc Browse For Me result link which could display whatever content I wanted."
    }), "\n", _jsxs(_components.blockquote, {
      children: ["\n", _jsx(_components.p, {
        children: "In this article, I’ll refer to The Browser Company of New York as “BCNY”, and Browse For Me as “BFM”."
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      children: "Update (2025-03-04)"
    }), "\n", _jsx(_components.p, {
      children: "BCNY seems to have resolved this issue... by disabling the sharing of BFM pages. The API endpoint seems to be down as well. Existing links however, still work."
    }), "\n", _jsx(_components.h2, {
      children: "The goal"
    }), "\n", _jsx(_components.p, {
      children: "Make a shared BFM link display whatever content I want."
    }), "\n", _jsx(_components.h2, {
      children: "What is Arc Search?"
    }), "\n", _jsx(_components.p, {
      children: "Arc Search is the mobile companion app to BCNY’s popular desktop browser, Arc. Arc Search’s claim to fame is Browse For Me, an AI-powered search engine, similar to Perplexity or SearchGPT. In the Arc Search app, you can press the share button in a BFM page, which generates a link you can share with your friends (i.e. https://search.arc.net/UYwUAKlR1Qm5fWDYuzPO)."
    }), "\n", _jsx(_components.h2, {
      children: "Backstory"
    }), "\n", _jsxs(_components.p, {
      children: ["Recently while I was using BFM on Arc Search, I began to wonder why sharing the page took a long time (~5-10 seconds). So, I fired up ", _jsx(_components.a, {
        href: "https://proxyman.io/ios",
        children: "Proxyman"
      }), " on my iPhone to intercept the HTTP traffic going to and from my phone, and what I found was surprising."]
    }), "\n", _jsx(_components.h2, {
      children: "How sharing a Browse For Me result works"
    }), "\n", _jsxs(_components.p, {
      children: ["When you press the Share button on a BFM page in Arc Search, it fires a ", _jsx(_components.code, {
        children: "POST"
      }), " request to ", _jsx(_components.code, {
        children: "https://search.arc.net/api/share"
      }), ". However, in the body of request, I found that the entire contents of the search page were sent as well. Here’s how a typical request looks:"]
    }), "\n", _jsx(_components.pre, {
      children: _jsxs(_components.code, {
        class: "language-http",
        children: [_jsx(_components.span, {
          class: "pl-k",
          children: "POST"
        }), _jsx(_components.span, {
          class: "pl-c1",
          children: " /api/share HTTP/1.1"
        }), "\n", _jsxs(_components.span, {
          class: "pl-s",
          children: [_jsx(_components.span, {
            class: "pl-v",
            children: "Content-Type:"
          }), " text/plain; charset=utf-8"]
        }), "\n", _jsxs(_components.span, {
          class: "pl-s",
          children: [_jsx(_components.span, {
            class: "pl-v",
            children: "Host:"
          }), " search.arc.net"]
        }), "\n", _jsxs(_components.span, {
          class: "pl-s",
          children: [_jsx(_components.span, {
            class: "pl-v",
            children: "Connection:"
          }), " close"]
        }), "\n", _jsxs(_components.span, {
          class: "pl-s",
          children: [_jsx(_components.span, {
            class: "pl-v",
            children: "Content-Length:"
          }), " 142321"]
        }), "\n"]
      })
    }), "\n", _jsx(_components.pre, {
      children: _jsxs(_components.code, {
        class: "language-json",
        children: ["{\n  ", _jsx(_components.span, {
          class: "pl-ent",
          children: "\"stream\""
        }), ": [],\n  ", _jsx(_components.span, {
          class: "pl-ent",
          children: "\"raw\""
        }), ": ", _jsx(_components.span, {
          class: "pl-s",
          children: _jsx(_components.span, {
            class: "pl-pds",
            children: "\"\""
          })
        }), ",\n  ", _jsx(_components.span, {
          class: "pl-ent",
          children: "\"shouldRetain\""
        }), ": ", _jsx(_components.span, {
          class: "pl-c1",
          children: "false"
        }), ",\n  ", _jsx(_components.span, {
          class: "pl-ent",
          children: "\"finished\""
        }), ": ", _jsx(_components.span, {
          class: "pl-c1",
          children: "true"
        }), "\n}\n"]
      })
    }), "\n", _jsxs(_components.p, {
      children: ["The ", _jsx(_components.code, {
        children: "raw"
      }), " key can be ignored, as the server also seems to ignore it. The real magic is in the ", _jsx(_components.code, {
        children: "stream"
      }), " key, which is an array of JSON objects. This contains everything that is displayed on the frontend."]
    }), "\n", _jsxs(_components.p, {
      children: ["All objects in ", _jsx(_components.code, {
        children: "stream"
      }), " have the following keys in common:"]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "title"
        }), ": string"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "type"
        }), ": string, can be one of the following:", "\n", _jsxs(_components.ul, {
          children: ["\n", _jsxs(_components.li, {
            children: [_jsx(_components.code, {
              children: "emojiList"
            }), " - A list with emoji as bullet points"]
          }), "\n", _jsxs(_components.li, {
            children: [_jsx(_components.code, {
              children: "sectionTitle"
            }), " - A subheading"]
          }), "\n", _jsxs(_components.li, {
            children: [_jsx(_components.code, {
              children: "userFeedback"
            }), " - Asks for user feedback"]
          }), "\n", _jsxs(_components.li, {
            children: [_jsx(_components.code, {
              children: "citation"
            }), " - A citation. This will show a “Verified” tag next to the url, regardless if it was fake."]
          }), "\n", _jsxs(_components.li, {
            children: [_jsx(_components.code, {
              children: "pageTitle"
            }), " - The title at the top of the page"]
          }), "\n"]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "isFinished"
        }), ": boolean"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "isPlaceholder"
        }), ": boolean\nThere are also other values in objects which differ depending on the ", _jsx(_components.code, {
          children: "type"
        }), "."]
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.strong, {
        children: "Any value in the body can be changed without the server caring"
      }), ", which means you can easily falsify results."]
    }), "\n", _jsx(_components.p, {
      children: "Once a link is created, the server sends a response like the following:"
    }), "\n", _jsx(_components.pre, {
      children: _jsxs(_components.code, {
        class: "language-http",
        children: [_jsx(_components.span, {
          class: "pl-c1",
          children: "HTTP/1.1 200 OK"
        }), "\n", _jsxs(_components.span, {
          class: "pl-s",
          children: [_jsx(_components.span, {
            class: "pl-v",
            children: "Cache-Control:"
          }), " public, max-age=0, must-revalidate"]
        }), "\n", _jsxs(_components.span, {
          class: "pl-s",
          children: [_jsx(_components.span, {
            class: "pl-v",
            children: "Content-Type:"
          }), " text/plain;charset=UTF-8"]
        }), "\n", _jsxs(_components.span, {
          class: "pl-s",
          children: [_jsx(_components.span, {
            class: "pl-v",
            children: "Date:"
          }), " Mon, 28 Oct 2024 20:30:45 GMT"]
        }), "\n", _jsxs(_components.span, {
          class: "pl-s",
          children: [_jsx(_components.span, {
            class: "pl-v",
            children: "Server:"
          }), " Vercel"]
        }), "\n", _jsxs(_components.span, {
          class: "pl-s",
          children: [_jsx(_components.span, {
            class: "pl-v",
            children: "Strict-Transport-Security:"
          }), " max-age=63072000"]
        }), "\n", _jsxs(_components.span, {
          class: "pl-s",
          children: [_jsx(_components.span, {
            class: "pl-v",
            children: "Vary:"
          }), " RSC, Next-Router-State-Tree, Next-Router-Prefetch, Next-Url"]
        }), "\n", _jsxs(_components.span, {
          class: "pl-s",
          children: [_jsx(_components.span, {
            class: "pl-v",
            children: "X-Matched-Path:"
          }), " /api/share"]
        }), "\n", _jsxs(_components.span, {
          class: "pl-s",
          children: [_jsx(_components.span, {
            class: "pl-v",
            children: "X-Vercel-Cache:"
          }), " MISS"]
        }), "\n", _jsxs(_components.span, {
          class: "pl-s",
          children: [_jsx(_components.span, {
            class: "pl-v",
            children: "X-Vercel-Id:"
          }), " cle1::iad1::wd6z4-1730147445251-0db83fb9f76c"]
        }), "\n", _jsxs(_components.span, {
          class: "pl-s",
          children: [_jsx(_components.span, {
            class: "pl-v",
            children: "Connection:"
          }), " close"]
        }), "\n", _jsxs(_components.span, {
          class: "pl-s",
          children: [_jsx(_components.span, {
            class: "pl-v",
            children: "Transfer-Encoding:"
          }), " chunked"]
        }), "\n"]
      })
    }), "\n", _jsx(_components.pre, {
      children: _jsxs(_components.code, {
        class: "language-json",
        children: ["{", _jsx(_components.span, {
          class: "pl-ent",
          children: "\"shareID\""
        }), ":", _jsxs(_components.span, {
          class: "pl-s",
          children: [_jsx(_components.span, {
            class: "pl-pds",
            children: "\""
          }), "PNmICgV7lW4zJxmVDr71", _jsx(_components.span, {
            class: "pl-pds",
            children: "\""
          })]
        }), "}\n"]
      })
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "shareID"
      }), " seems to be the link’s ID. I navigated to ", _jsx(_components.code, {
        children: "https://search.arc.net/<id>"
      }), ", and lo and behold, my content was there!"]
    }), "\n", _jsx(_components.p, {
      children: _jsx(_components.img, {
        src: "/blog-images/bfm-desktop.jpeg",
        alt: "BFM showing custom page on desktop"
      })
    }), "\n", _jsx(_components.p, {
      children: "It even works on the Arc Search app, when visiting the shared link:"
    }), "\n", _jsx(_components.p, {
      children: _jsx(_components.img, {
        src: "/blog-images/bfm-mobile.jpg",
        alt: "Arc Search on iOS showing custom page"
      })
    }), "\n", _jsx(_components.h2, {
      children: "What are the risks?"
    }), "\n", _jsx(_components.p, {
      children: "The ability to create custom search results brings with it dire consequences, most alarmingly the ability to falsify search results and pass them off as legitimate. For example, my hijacked page includes a fake quote from https://arc.net, which displays a “Verified” tag next to it."
    }), "\n", _jsx(_components.p, {
      children: _jsx(_components.img, {
        src: "/blog-images/bfm-fake-quote.jpg",
        alt: "Fake quote from arc.net"
      })
    }), "\n", _jsx(_components.p, {
      children: "This creates a risk of misinformation being spread through Arc Search, while it appears to be a legitimate search result. For example, a search for “Who won the 2020 US election?” could be modified to state the winner was Kermit the Frog. The link could then be shared online, and convince some people of the fabricated result."
    }), "\n", _jsx(_components.h2, {
      children: "Demo"
    }), "\n", _jsxs(_components.p, {
      children: ["You can see a live version of a fake search page ", _jsx(_components.a, {
        href: "https://search.arc.net/PNmICgV7lW4zJxmVDr71",
        children: "here"
      }), ", and an archived version is available ", _jsx(_components.a, {
        href: "https://archive.is/D9MYb",
        children: "here"
      }), " in case BCNY takes it down or they go out of business (VC money doesn’t last forever). For research purposes, the exact request body I used to generate it can be found ", _jsx(_components.a, {
        href: "https://rentry.org/sqpu4hwu",
        children: "here"
      }), "."]
    }), "\n", _jsx(_components.h2, {
      children: "Fix and Conclusion"
    }), "\n", _jsx(_components.p, {
      children: "BCNY can fix this issue by generating a fixed link when a result is first generated and keep the process completely opaque from the client, similar to what competing services do already. But for now, this has been BomberFish, and I do declare; end broadcast."
    })]
  });
}
export function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}


		export default function Page() {
			const {wrapper: MDXLayout} = this.components || ({});
			return (
				MDXLayout 
					? _jsx(MDXLayout, { children: [_createMdxContent(this)], ...this })
					: _createMdxContent(this)
			)
		}
	